'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  CRM: 'CRM',
  SALES_HUB: 'SALES_HUB'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-i18n/static-1.2379/js/constants/SupportedPhoneNumberTypes.js
// module id = 566
// module chunks = 3 4 5